import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { formatInTimeZone } from "date-fns-tz";
import { useCallback } from "react";

import { RestrictedPageContent } from "./PageContent";

export function RestrictedPage() {
  const { userId, tmz } = useDefinedWorker();
  const { data: clipboardScoreData, refetch: refetchClipboardScoreProfile } =
    useGetClipboardScoreProfile(userId);

  const refreshAllData = useCallback(async () => {
    await refetchClipboardScoreProfile();
  }, [refetchClipboardScoreProfile]);

  const reEnrollmentDate = clipboardScoreData?.accountStatus?.reEnrollmentDate;
  const formattedLiftDate = reEnrollmentDate
    ? formatInTimeZone(parseISO(reEnrollmentDate), tmz, "MMM d, yyy h:mm aa")
    : undefined;

  return <RestrictedPageContent liftDate={formattedLiftDate} onRefresh={refreshAllData} />;
}
